import { EVENT_PAYLOAD, IMPRESSION_PAYLOAD, } from '#pplx/frontend/framework/instrumentation/types.js';
export const upsellClickedEvent = EVENT_PAYLOAD;
export const upsellViewedEvent = IMPRESSION_PAYLOAD;
export const upsellDismissedEvent = EVENT_PAYLOAD;
//# sourceMappingURL=analytics.js.map